import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const discord = defineConnector({
  identifier: "discord",
  name: "Discord",
  tagLine: "Community and team chat",
  keywords: "guilds servers channels dms messaging bot voice",
  logo,
  protocol: "http",
  tags: ["featured", "communication"],
  defaultUrlPattern: () => "https://discord\\.com/api/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.botToken,
        scheme: "Bot",
      },
    ]),
  steps: [
    {
      title: "Create a Discord bot",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [Discord Developer Portal](https://discord.com/developers/applications) and create a new application, or select an existing one.\n\nNavigate to the **Bot** tab and create a bot if you haven’t already. Enable the necessary intents for your use case.",
        },
      ],
    },
    {
      title: "Copy and paste your bot token here",
      items: [
        {
          kind: "markdown",
          content:
            "On the **Bot** tab, click **Reset Token** (or **Copy** if you haven’t done so yet) to get your bot token.\n\n**Keep this token secret** — anyone with access can control your bot.",
        },
        {
          kind: "input",
          label: "Bot token",
          placeholder: "MTIzNDU2Nzg5MDEyMzQ1Njc4OQ...",
          required: true,
          target: { kind: "secrets", field: "botToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://discord.com/api/v10/users/@me",
  },
});
